import React from "react";
import ReactApexChart from "react-apexcharts";
import {
  InsightDurationDaily,
  InsightDurationMonthly,
  InsightDurationWeekly,
} from "../../../libs";

export const ProfitsChartElement = ({
  data,
  options,
  series,
  lang,
  activeChoice,
  setActiveChoice,
  selectDataType,
}) => {
  return (
    <>
      <select
        className="form-select inter-bold graph-filters-type-selector"
        onChange={(e) => {
          selectDataType(e.target.value);
        }}
        style={{
          width: "12rem",
          display: "inline",
          fontSize: "1rem",
          border: "none",
        }}
      >
        <option value="profits">
          {window.sys_app_translate("Profit Details", lang)}
        </option>
        <option value="insurancestotal">
          {window.sys_app_translate("Insurances Total", lang)}
        </option>
        <option value="insurancescount">
          {window.sys_app_translate("Insurances Count", lang)}
        </option>
        <option value="agenciescount">
          {window.sys_app_translate("Agencies Count", lang)}
        </option>
      </select>
      <div className="graph-filters-container">
        <ul>
          <li
            className={
              "inter inter-medium " +
              (activeChoice === InsightDurationMonthly ? "active" : "")
            }
            onClick={() => {
              setActiveChoice(InsightDurationMonthly);
            }}
            style={{ userSelect: "none" }}
          >
            {window.sys_app_translate("Monthly", lang)}
          </li>
          <li
            className={
              "inter inter-medium " +
              (activeChoice === InsightDurationWeekly ? "active" : "")
            }
            onClick={() => {
              setActiveChoice(InsightDurationWeekly);
            }}
            style={{ userSelect: "none" }}
          >
            {window.sys_app_translate("Weekly", lang)}
          </li>
          <li
            className={
              "inter inter-medium " +
              (activeChoice === InsightDurationDaily ? "active" : "")
            }
            style={{ userSelect: "none" }}
            onClick={() => {
              setActiveChoice(InsightDurationDaily);
            }}
          >
            {window.sys_app_translate("Daily", lang)}
          </li>
        </ul>
      </div>
      <div
        id="chart"
        style={{ position: "relative" }}
        className="profits-chart"
      >
        <ReactApexChart
          options={{
            chart: {
              type: "bar",
              height: "100%",
              background: "#ffffff",
            },
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 5,
                borderRadiusApplication: "end",
                columnWidth: "12px",
              },
            },
            colors: ["#199B8B"],
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              categories: series,
            },
            responsive: [
              {
                breakpoint: 1024,
                options: {
                  plotOptions: {
                    bar: {
                      horizontal: false,
                      borderRadius: 5,
                      borderRadiusApplication: "end",
                      columnWidth: "12px",
                    },
                  },
                },
              },
            ],
          }}
          series={[
            {
              data: data,
            },
          ]}
          type="bar"
          height={350}
        />
      </div>
    </>
  );
};
